var map = {
	"./base.jpg": 6110,
	"./coastal.jpg": 3940,
	"./futuristic.jpg": 7157,
	"./luxury.jpg": 9142,
	"./metropolitan.jpg": 8727,
	"./nature.jpg": 1204,
	"./noir.jpg": 9181,
	"./rural.jpg": 5025,
	"./skyline.jpg": 8392,
	"./vibrance.jpg": 9039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 874;